import React from 'react';
import { getDataTestId } from '../../../../shared/esm';
import { BackspaceXxlIcon } from '@alfalab/icons-glyph/BackspaceXxlIcon';
import { KeyPadButton } from '../KeyPadButton/Component.js';
import 'tslib';
import 'classnames';
import '../../../../button/esm/mobile';

var styles = {"component":"pass-code__component_qqsju","digit":"pass-code__digit_qqsju"};
require('./index.css');

var CELL_COUNT = 12;
var CELLS = new Array(CELL_COUNT).fill(null).map(function (_, i) {
    if (i === 10)
        return 0;
    return i + 1;
});
var KeyPad = function (_a) {
    var leftAddons = _a.leftAddons, rightAddons = _a.rightAddons, rightAddonsTitle = _a.rightAddonsTitle, onClick = _a.onClick, onClear = _a.onClear, showClear = _a.showClear, dataTestId = _a.dataTestId;
    return (React.createElement("div", { className: styles.component, "data-test-id": getDataTestId(dataTestId, 'keypad') }, CELLS.map(function (digit, i) {
        if (i === 9) {
            if (leftAddons)
                return leftAddons;
            return React.createElement("div", { key: 'left-addons-empty' });
        }
        if (i === 11) {
            if (showClear) {
                return (React.createElement(KeyPadButton, { key: 'clear-btn', onClick: onClear, view: 'text', dataTestId: getDataTestId(dataTestId, 'backspace-button'), title: '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0441\u0438\u043C\u0432\u043E\u043B' },
                    React.createElement(BackspaceXxlIcon, null)));
            }
            if (rightAddons) {
                if (rightAddonsTitle) {
                    return React.createElement("div", { title: rightAddonsTitle }, rightAddons);
                }
                return rightAddons;
            }
            return React.createElement("div", { key: 'right-addon-empty' });
        }
        return (React.createElement(KeyPadButton, { key: digit, onClick: onClick, view: 'secondary', buttonClassName: styles.digit, dataTestId: getDataTestId(dataTestId, 'keypad-button') }, digit));
    })));
};

export { KeyPad };
